import React from 'react';
import { MapPin, Phone, Mail, ExternalLink } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#3A0000] text-white/80 pt-16 pb-8 border-t-4 border-[#800000]" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-110">
          {/* Column 1: Lab Info */}
          <div className="space-y-6" data-id="element-111">
            <div className="flex items-center gap-3" data-id="element-112">
              <img src="https://cdn.magicpatterns.com/uploads/5aPbZKWy7kwepY8EBvvSMu/imgi_19_download-removebg-preview.png" alt="IIT Madras Logo" className="h-12 w-auto brightness-0 invert" data-id="element-113" />
              <span className="text-2xl font-serif font-bold text-white tracking-wider" data-id="element-114">
                MT²RL
              </span>
            </div>
            <p className="text-sm leading-relaxed" data-id="element-115">
              Advancing thermal transport science through multiscale research at
              the Indian Institute of Technology Madras.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-116">
            <h4 className="text-lg font-bold text-white font-serif mb-6 relative inline-block" data-id="element-117">
              Quick Links
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-[#800000]" data-id="element-118"></span>
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-119">
              <li data-id="element-120">
                <a href="#home" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-121">
                  <span className="text-[#800000]" data-id="element-122">›</span> Home
                </a>
              </li>
              <li data-id="element-123">
                <a href="#research" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-124">
                  <span className="text-[#800000]" data-id="element-125">›</span> Research
                </a>
              </li>
              <li data-id="element-126">
                <a href="#publications" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-127">
                  <span className="text-[#800000]" data-id="element-128">›</span> Publications
                </a>
              </li>
              <li data-id="element-129">
                <a href="#projects" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-130">
                  <span className="text-[#800000]" data-id="element-131">›</span> Projects
                </a>
              </li>
              <li data-id="element-132">
                <a href="#equipment" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-133">
                  <span className="text-[#800000]" data-id="element-134">›</span> Equipment
                </a>
              </li>
              <li data-id="element-135">
                <a href="#gallery" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-136">
                  <span className="text-[#800000]" data-id="element-137">›</span> Gallery
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div data-id="element-138">
            <h4 className="text-lg font-bold text-white font-serif mb-6 relative inline-block" data-id="element-139">
              Contact Us
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-[#800000]" data-id="element-140"></span>
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-141">
              <li className="flex items-start gap-3" data-id="element-142">
                <MapPin size={18} className="text-[#800000] shrink-0 mt-0.5" data-id="element-143" />
                <span data-id="element-144">
                  Room # HTTP 104, Dept. of Mechanical Engineering, IIT Madras,
                  Chennai 600 036
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-145">
                <Phone size={18} className="text-[#800000] shrink-0" data-id="element-146" />
                <a href="tel:+914422574654" className="hover:text-white transition-colors" data-id="element-147">
                  +91 44 2257 4654(O)
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-148">
                <Mail size={18} className="text-[#800000] shrink-0" data-id="element-149" />
                <a href="mailto:arvindp@iitm.ac.in" className="hover:text-white transition-colors" data-id="element-150">
                  arvindp@iitm.ac.in
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div data-id="element-151">
            <h4 className="text-lg font-bold text-white font-serif mb-6 relative inline-block" data-id="element-152">
              Connect
              <span className="absolute -bottom-2 left-0 w-1/2 h-0.5 bg-[#800000]" data-id="element-153"></span>
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-154">
              <li data-id="element-155">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-156">
                  <ExternalLink size={14} className="text-[#800000] group-hover:text-white transition-colors" data-id="element-157" />
                  IIT Madras Website
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-159">
                  <ExternalLink size={14} className="text-[#800000] group-hover:text-white transition-colors" data-id="element-160" />
                  Mechanical Engineering Dept
                </a>
              </li>
              <li data-id="element-161">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2 group" data-id="element-162">
                  <ExternalLink size={14} className="text-[#800000] group-hover:text-white transition-colors" data-id="element-163" />
                  Google Scholar Profile
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-164">
          <p data-id="element-165">
            © {new Date().getFullYear()} Crafted by MT²RL Laboratory, IIT
            Madras. All rights reserved.
          </p>
          <p data-id="element-166">Designed for Multiscale Thermal Transport Research</p>
        </div>
      </div>
    </footer>;
}